import { render, staticRenderFns } from "./upload-com.vue?vue&type=template&id=71fa0fc2&"
import script from "./upload-com.vue?vue&type=script&lang=js&"
export * from "./upload-com.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports